export enum EventActionEnum {
  Clic = 'Clic',
  Sortie = 'eof',
  Entree = 'entree',
  Debuter = 'debute',
  Completer = 'complete',
  Annuler = 'annuler',
  ErreurTechnique = 'erreur technique',
  ErreurUtilisateur = 'erreur utilisateur',
  Ouverture = 'Ouverture'
}
